export enum AllowedLangsEnum {
  EN = 'en',
  DE = 'de',
  // CH = 'ch',
}

export enum AllowedLocalesEnum {
  EN = 'en',
  AT = 'at',
  DE = 'de',
  // CH = 'ch',
}
